import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import SectionHeading from '../components/SectionHeading';

import CallToAction from './CallToAction';
// Styles
import './Card.scss';

const noop = () => {};

const Card = ({
  image = null,
  alt = '',
  cardTitle = null,
  callToActionPath = '',
  callToActionText = '',
  children = null,
  onClick = noop,
  headingLevel = 3,
  headingType = 'capitalize',
  headingAlign = 'left',
  headingSize = 'large',
  headingTheme = 'dark',
  dataTest = 'generic-call-to-action'
}) => {
  return (
    <div className="card__wrapper">
      <img src={image} className="card__img" alt={alt} />
      <div className="card__body">
        <SectionHeading
          text={cardTitle}
          level={headingLevel}
          type={headingType}
          align={headingAlign}
          size={headingSize}
          theme={headingTheme}
        />
        {children}
        <CallToAction
          className="card__btn"
          href={callToActionPath}
          text={trans(callToActionText)}
          onClick={onClick}
          color="filled"
          dataTest={dataTest}
        />
      </div>
    </div>
  );
};

Card.propTypes = {
  cardTitle: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.string,
  alt: PropTypes.string,
  callToActionPath: PropTypes.string,
  callToActionText: PropTypes.string,
  onClick: PropTypes.func,
  headingLevel: PropTypes.number,
  headingType: PropTypes.string,
  headingAlign: PropTypes.string,
  headingSize: PropTypes.string,
  headingTheme: PropTypes.string,
  dataTest: PropTypes.string
};

export default Card;
